import { theme } from 'antd';

const { useToken } = theme;

// In-memory patient store
let patientsData = [
  { 
    id: 'P001', 
    name: 'Sarah Johnson', 
    age: 42, 
    status: 'Active', 
    appointment: 'Today, 2:30 PM', 
    condition: 'Hypertension',
    lastVisit: '2 days ago',
    avatarColor: null // Will be set dynamically
  },
  { 
    id: 'P002', 
    name: 'Michael Chen', 
    age: 35, 
    status: 'Active', 
    appointment: 'Tomorrow, 10:00 AM', 
    condition: 'Diabetes Type 2',
    lastVisit: 'Yesterday',
    avatarColor: null
  },
  { 
    id: 'P003', 
    name: 'Emma Wilson', 
    age: 28, 
    status: 'Active', 
    appointment: 'Apr 10, 11:15 AM', 
    condition: 'Pregnancy - 2nd Trimester',
    lastVisit: '1 week ago',
    avatarColor: null
  },
  { 
    id: 'P004', 
    name: 'James Rodriguez', 
    age: 52, 
    status: 'Inactive', 
    appointment: 'None', 
    condition: 'Arthritis',
    lastVisit: '3 weeks ago',
    avatarColor: null
  },
  { 
    id: 'P005', 
    name: 'Linda Thompson', 
    age: 63, 
    status: 'Active', 
    appointment: 'Apr 12, 9:45 AM', 
    condition: 'COPD',
    lastVisit: '5 days ago',
    avatarColor: null
  },
];

export const usePatients = () => {
  const { token } = useToken();
  
  // Assign avatar colors dynamically
  const colors = [token.blue6, token.green6, token.orange6, token.purple6, token.red6];
  return patientsData.map((patient, index) => ({
    ...patient,
    avatarColor: colors[index % colors.length]
  }));
};

export const addPatient = (newPatient) => {
  const { token } = theme.useToken();
  const colors = [token.blue6, token.green6, token.orange6, token.purple6, token.red6];
  const newId = `P${(patientsData.length + 1).toString().padStart(3, '0')}`;
  const patient = {
    id: newId,
    name: newPatient.names[0]?.given || 'Unknown',
    age: newPatient.birthDate ? Math.floor((new Date() - new Date(newPatient.birthDate)) / (1000 * 60 * 60 * 24 * 365)) : 0,
    status: 'Active',
    appointment: 'None',
    condition: 'Unknown',
    lastVisit: 'Never',
    avatarColor: colors[patientsData.length % colors.length]
  };
  patientsData.push(patient);
};